import { lojaInterface } from "@/app/utils/utils";

import React from "react";

interface OperatingHoursItemProps {
	title: string;
	hours: string[];
}

const OperatingHoursItem: React.FC<OperatingHoursItemProps> = ({
	title,
	hours,
}) => (
	<div className="flex flex-col px-2 mt-4">
		<h3 className="text-base font-semibold leading-6">{title}</h3>
		<div className="mt-1 text-sm leading-5">
			{hours?.map((hour, index) => (
				<React.Fragment key={title + hour + index}>
					{hour}
					<br />
				</React.Fragment>
			))}
		</div>
	</div>
);

const OperatingHours = ({ loja }: { loja: lojaInterface | undefined }) => {
	return (
		<div className="flex flex-col ml-5 w-[43%] max-md:ml-0 max-md:w-full">
			<div className="flex flex-col grow p-6 text-white max-md:px-5 max-md:mt-4">
				<div className="flex text-base font-semibold leading-6">
					<img
						width={400}
						height={400}
						loading="lazy"
						src="/images/relogio.svg"
						alt=""
						className="shrink-0 self-start w-5 aspect-square"
					/>
					<h2 className="flex-1 px-4">Horário de Funcionamento</h2>
				</div>
				<OperatingHoursItem
					title={"Horário Showroom"}
					hours={loja?.hShow?.split(" ,")!}
				/>
				{loja?.hService && (
				<OperatingHoursItem
					title={"Horário Serviço"}
					hours={loja?.hService?.split(" ,")!}
					/>
				)}
				{loja?.hPosVenda && (
					<OperatingHoursItem
						title={"Horário Pós-venda"}
						hours={loja?.hPosVenda?.split(" ,")!}
					/>
				)}
				{loja?.hPecas && (
					<OperatingHoursItem
					title={"Horário Peças"}
					hours={loja?.hPecas?.split(" ,")!}
					/>
				)}
			</div>
		</div>
	);
};

export default OperatingHours;
